import React, { createContext, useContext, useState, useEffect } from 'react';

const ScenarioContext = createContext();

export const ScenarioProvider = ({ children }) => {
  const [currentScenario, setCurrentScenario] = useState(null);

  useEffect(() => {
    const storedScenario = sessionStorage.getItem('currentScenario');
    if (storedScenario) {
      try {
        setCurrentScenario(JSON.parse(storedScenario));
      } catch (error) {
        console.error('Error parsing stored scenario:', error);
        sessionStorage.removeItem('currentScenario');
      }
    }
  }, []);

  const selectScenario = (scenario) => {
    setCurrentScenario(scenario);
    sessionStorage.setItem('currentScenario', JSON.stringify(scenario));
  };

  const clearScenario = () => {
    setCurrentScenario(null);
    sessionStorage.removeItem('currentScenario');
  };

  return (
    <ScenarioContext.Provider value={{ currentScenario, selectScenario, clearScenario }}>
      {children}
    </ScenarioContext.Provider>
  );
};

export const useScenario = () => useContext(ScenarioContext);

export default ScenarioContext;